import React, { useState, useEffect } from 'react'
import { getIdData } from '../../lib/studentinfo'
import { getFile } from '../../lib/file'

const StudentInfoBox = ({ slug }) => {
	const [studentInfo, setStudentInfo] = useState(null)
	const [avatar, setAvatar] = useState(null)

	const fetchStudentData = async () => {
		try {
			const std = await getIdData(slug)
			setStudentInfo(std)

			if (std[0]?.avatar_url) {
				const avt = await getFile(std[0].avatar_url)
				setAvatar(avt.publicUrl)
			}
		} catch (error) {
			console.error('Error fetching student data:', error)
		}
	}

	useEffect(() => {
		fetchStudentData()
	}, [slug])

	if (!studentInfo || !studentInfo[0]) {
		return null
	}

	const student = studentInfo[0]

	return (
		<div className="settings-widget mb-5">
			<div className="settings-inner-blk p-0">
				<div className="row m-2">
					<div className="col-3">
						<div className="student-img">
							<img
								className="rounded-circle float-start"
								style={{ height: '100px', width: '100px', objectFit: 'cover' }}
								alt="Student Avatar"
								src={avatar || require('../../assets/images/user/user-dp.png')}
							/>
						</div>
					</div>
					<div className="col-9 align-items-center mt-3">
						<h3>{student.name ? `${student.name} ${student.surname || ''}`.trim() : 'Student Name Not Found'}</h3>
						<p className="text-muted">{student.schoolname ? `${student.schoolname} - ${student.class || ''}` : 'School Information Not Found'}</p>
						{student.email && (
							<p className="text-muted mb-0">
								<i className="fa fa-envelope me-2"></i>
								{student.email ? student.email : 'Email Not Found'}
							</p>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default StudentInfoBox
